<template>
  <div class="shipmentocean__tabs--contain">
    <p class="fontstyle__default--blue mb-2">Enter Your Shipment Data</p>
    <div class="row m-0 mb-2">
      <div class="mr-3" style="width: 22%">
        <!-- FCL Type -->
        <p class="fontstyle__infotext">{{fieldName.fcl}}</p>
        <div class="options__multipleselect">
          <multiselect
            :name="fieldName.fcl"
            :error-messages="errors.collect(fieldName.fcl)"
            v-model="formData.shipment_type"
            @input="chooseOptions(formData.shipment_type, 'FCLTYPE')"
            :options="fclTypeOptions"
            label="text"
            placeholder="Select"
            v-validate="'required'"
            :select-label="''" :deselect-label="''">
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
        </div>
        <p v-if="error.shipment_type" class="fontstyle__errormsg">
          <span v-for="item in error.shipment_type" :key="item.id">{{item.msg}}</span>
        </p>
      </div>

      <div class="mr-3" style="width: 22%">
        <!-- Container Type -->
        <p class="fontstyle__infotext">{{fieldName.container}}</p>
        <div class="options__multipleselect">
          <multiselect
            :name="fieldName.container"
            :error-messages="errors.collect(fieldName.container)"
            v-model="formData.containerSize"
            @input="chooseOptions(formData.containerSize, 'CTRTYPE')"
            :options="containerTypeOptions"
            label="text"
            placeholder="Select"
            v-validate="'required'"
            :select-label="''" :deselect-label="''">
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
        </div>
        <p v-if="error.container" class="fontstyle__errormsg">
          <span v-for="item in error.container" :key="item.id">{{item.msg}}</span>
        </p>
      </div>

      <div v-if="formData.containerSize && formData.containerSize.value === 'Reefer'"
           style="width: 10%;"
           class="input__model1group mr-3">
           <!-- Temperature -->
        <p class="textdefault">{{fieldName.temp}}</p>
        <b-form-input
          :name="fieldName.temp"
          :error-messages="errors.collect(fieldName.temp)"
          v-model="formData.temperature"
          v-validate="'required'"
          type="number"
          placeholder="C"
        />
        <p v-if="error.temperature" class="fontstyle__errormsg">
          <span v-for="item in error.temperature" :key="item.id">{{item.rule}}</span>
        </p>
      </div>

      <div style="width: 15%;" class="input__model1group mr-3">
        <!-- Total Shipment -->
        <p class="textdefault">{{fieldName.totShipment}}</p>
        <b-form-input
          :name="fieldName.totShipment"
          :error-messages="errors.collect(fieldName.totShipment)"
          v-validate="'required'"
          type="number"
          min="0"
          :keyup="calcEstimatePerMonth()"
          v-model="formData.totalshipment"
          placeholder="0"
        />
        <p v-if="error.totalshipment" class="fontstyle__errormsg">
         <span v-for="item in error.totalshipment" :key="item.id">{{item.msg}}</span>
        </p>
      </div>

      <div style="width: 15%;" class="input__model1group mr-3">
        <!-- Total Container -->
        <p class="textdefault">{{fieldName.totContainer}}</p>
        <b-form-input
          :name="fieldName.totContainer"
          :error-messages="errors.collect(fieldName.totContainer)"
          v-validate="'required'"
          type="number"
          min="0"
          :keyup="calcEstimatePerMonth()"
          v-model="formData.total_weight"
          placeholder="0"
        />
        <p v-if="error.total_weight" class="fontstyle__errormsg">
         <span v-for="item in error.total_weight" :key="item.id">{{item.msg}}</span>
        </p>
        <p class="fontstyle__errormsg" v-if="!cekEstimaterequired(formData.total_weight, formData.totalshipment)">
          This Total Container must be more or equal with Total Shipment
        </p>
      </div>

      <div class="input__model1group"
           style="width: 18%;">
        <!-- Estimate Total Weight -->
        <p class="textdefault">{{fieldName.weight}}</p>
        <b-input-group append="Kg">
          <b-form-input
            :name="fieldName.weight"
            :error-messages="errors.collect(fieldName.weight)"
            v-validate="'required'"
            type="number"
            min="0"
            placeholder="0"
            v-model="formData.weight_estimation"
          />
        </b-input-group>
        <p v-if="error.weight_estimation" class="fontstyle__errormsg">
         <span v-for="item in error.weight_estimation" :key="item.id">{{item.msg}}</span>
        </p>
      </div>
    </div>

    <div class="row m-0">
      <div style="width: 46%" class="mr-3">
        <!-- Container Option -->
        <p class="fontstyle__infotext">{{fieldName.containerOpt}}</p>
        <div class="options__multipleselect">
          <multiselect
            :name="fieldName.containerOpt"
            :error-messages="errors.collect(fieldName.containerOpt)"
            v-model="formData.container_option"
            @input="chooseOptions(formData.container_option, 'CTROPT')"
            :options="containerOptions"
            label="text"
            placeholder="Select"
            v-validate="'required'"
            :select-label="''" :deselect-label="''">
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
        </div>
        <p v-if="error.container_option" class="fontstyle__errormsg">
         <span v-for="item in error.container_option" :key="item.id">{{item.msg}}</span>
        </p>
      </div>

      <div class="input__model1group"
           style="width: 25%;">
        <!-- Estimate Container/Shipment -->
        <p class="textdefault">{{fieldName.estimatedDimention}}</p>
        <b-input-group append="Container">
          <b-form-input
            :name="fieldName.estimatedDimention"
            :error-messages="errors.collect(fieldName.estimatedDimention)"
            disabled
            type="number"
            min="0"
            placeholder="0"
            v-model="data.estimateddimention"
          />
        </b-input-group>
      </div>
    </div>
  </div>
</template>

<script>
import { UNIT_COMMODITY_QUANTITY_FCL } from '@/constant/options_list'
import ShipmentData from '@/components/requestShipment/components/ShipmentData'

export default {
  name: 'FCL',
  props: {
    showError: Boolean,
    showErrorFCL: Array,
    selectedTab: String
  },
  components: {
    ShipmentData
  },
  inject: ['parentValidator'],
  created () {
    this.$validator = this.parentValidator
  },
  data () {
    return {
    // weight 20 => standard
    // 40 => overweight
      isC20ft: true,
      isC40ft: false,
      isC40fthc: false,
      isC20fr: false,
      isC40fr: false,
      type: 'Ocean',
      ifReefer: false,
      totalUnit: 0,
      totalWeight: 0,
      optionQtyUnit: UNIT_COMMODITY_QUANTITY_FCL,
      fieldName: {
        fcl: 'FCL Type',
        container: 'Container Type',
        temp: 'Temperature',
        totShipment: 'Total Shipment',
        totContainer: 'Total Container',
        weight: 'Estimate Total Weight',
        containerOpt: 'Container Option',
        estimatedDimention: 'Estimate Container/Shipment'
      },
      data: {
        shipment_type: '', // FCL Type
        service_head: 'OCEAN',
        estimateddimention: 0,
        service_sub_type: 'Dry',
        totalshipment: '', // Total Shipment
        total_weight: '', // Total Container
        total_container: '',
        total_container_per_month: 0,
        temperature: '',
        total_quantity: '',
        containerSize: '20FT',
        satuan: 'Container',
        container_option: '',
        weight_estimation: '' // Estimate Total Weight
      },
      form: {
        typeObj: 'sub',
        loadsFCL: []
      },
      formData: {
        shipment_type: '', // FCL Type
        containerSize: '', // Container Type
        temperature: '', // reefer - Temperature
        totalshipment: '', // Total Shipment
        total_weight: '', // Total Container
        weight_estimation: '', // Estimate Total Weight
        container_option: '', // Container Option
        estimateddimention: 0 // estimate container shipment'
      },
      errorData: {
        errorsFCL: false
      },
      error: {
        shipment_type: false, // FCL Type
        containerSize: false, // Container Type
        temperature: false, // reefer - Temperature
        totalshipment: false, // Total Shipment
        total_weight: false, // Total Container
        weight_estimation: false, // Estimate Total Weight
        container_option: false, // Container Option
        estimateddimention: false // estimate container shipment'
      },
      fclTypeOptions: [
        { id: 1, text: '20 FT Container', value: '20FT', shipment_type: 'SEAFCL20FT' },
        { id: 2, text: '40 FT Container', value: '40FT', shipment_type: 'SEAFCL40FT' },
        { id: 3, text: '45 FT Container', value: '45FT', shipment_type: 'SEAFCL45FT' },
        { id: 4, text: '20 RF Container', value: '20RF', shipment_type: 'SEAFCL20RF' },
        { id: 5, text: '40 HREF Container', value: '40HREF', shipment_type: 'SEAFCL40HREF' },
        { id: 6, text: '40 FT High Cube', value: '40FT HC', shipment_type: 'SEAFCL40FTHC' },
        { id: 7, text: '20 FR Container', value: '20FR', shipment_type: 'SEAFCL20FR' },
        { id: 8, text: '40 FR Container', value: '40FR', shipment_type: 'SEAFCL40FR' }
      ],
      containerTypeOptions: [
        { id: 1, text: 'Dry', value: 'Dry' },
        { id: 2, text: 'Ventilate', value: 'Ventilate' },
        { id: 3, text: 'Reefer', value: 'Reefer' },
        { id: 4, text: 'Open Top', value: 'Open Top' },
        { id: 5, text: 'ISO Tank', value: 'ISO Tank' },
        { id: 6, text: 'NOR', value: 'NOR' }
      ],
      containerOptions: [
        { id: 1, text: "Shipper's Own Container (SOC)", value: 'SOC' },
        { id: 2, text: "Carrier's Owned Container (COC)", value: 'COC' }
      ]
    }
  },
  computed: {
    typingTemperature () {
      return this.formData.temperature
    },
    typingTotalshipment () {
      return this.formData.totalshipment
    },
    typingTotalContainer () {
      return this.formData.total_weight
    },
    typingTotalWeight () {
      return this.formData.weight_estimation
    }
  },
  watch: {
    showErrorFCL (value) {
      if (value) {
        this.error = {
          shipment_type: value.filter(item => item.field === this.fieldName.fcl),
          containerSize: value.filter(item => item.field === this.fieldName.container),
          totalshipment: value.filter(item => item.field === this.fieldName.totShipment),
          total_weight: value.filter(item => item.field === this.fieldName.totContainer),
          weight_estimation: value.filter(item => item.field === this.fieldName.weight),
          container_option: value.filter(item => item.field === this.fieldName.containerOpt),
          temperature: value.filter(item => item.field === this.fieldName.temp)
        }
      }
    },
    typingTemperature (value) {
      this.error.temperature = !!value
      this.data.temperature = value
      this.pushData()
    },
    typingTotalshipment (value) {
      if (value) {
        this.error.totalshipment = !!value
        this.data.totalshipment = parseInt(value)
        this.pushData()
      }
    },
    typingTotalContainer (value) {
      if (value) {
        this.error.total_weight = !!value
        this.data.total_weight = parseInt(value) || ''
        this.data.total_quantity = parseInt(value) || ''
        this.pushData()
      }
    },
    typingTotalWeight (value) {
      if (value) {
        this.error.weight_estimation = !!value
        this.data.weight_estimation = parseFloat(value) || ''
        this.pushData()
      }
    }
  },
  methods: {
    chooseOptions (item, category) {
      if (category === 'FCLTYPE') {
        this.data.shipment_type = item.shipment_type
      } else if (category === 'CTRTYPE') {
        this.data.containerSize = item.value
        this.data.service_sub_type = item.value
      } else if (category === 'CTROPT') {
        this.data.container_option = item.value
      }
      this.pushData()
    },
    pushData () {
      this.$emit('inputData', this.data)
    },
    getContainerValue (item) {
      if (item === 'SOC') {
        return "Shipper's Own Container (SOC)"
      } else {
        return "Carrier's Owned Container (COC)"
      }
    },
    calcTotalShipment () {
      const ojct = this.formData
      let tempTotal = 0
      let total = 0 
      if (ojct.total_weight && ojct.totalshipment && ojct.total_quantity) {
        tempTotal = ojct.total_weight * ojct.total_quantity
        total = this.type === 'courier'
          ? this.roundToHalf(tempTotal) / parseInt(ojct.totalshipment)
          : Math.ceil(tempTotal) / parseInt(ojct.totalshipment)
      }
      this.totalWeightPerShipment = total.toFixed(2)
    },

    cekEstimaterequired (container, shipment) {
      let status = true
      if (container && shipment && (parseInt(container) <= parseInt(shipment))) {
        status = false
      }
      return status
    },
    
    calcEstimatePerMonth () {
      const ojct = this.formData
      let total = 0
      if (ojct.total_weight && ojct.totalshipment) {
        total = parseInt(ojct.total_weight) / parseInt(ojct.totalshipment)
      }
      this.data.total_container_per_month = Math.ceil(total)
      this.data.estimateddimention = Math.ceil(total)
    }
  },
  mounted () {
    this.pushData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/ShipmentType/FCL.vue